import { useMemo } from 'react'
import { StatePlayer } from 'player'
import { TaskOperations } from '../../../../types'
import { UsePersistedSettings } from '../../../../hooks/player/use-persisted-channel-settings'

interface UseInitialStateProps {
  mainOperations: TaskOperations[]
  persistedSettings: UsePersistedSettings
}

export const useInitialStateSingleTrack = ({
  // mainOperations,
  persistedSettings
}: UseInitialStateProps): StatePlayer => {
  const { onGetSettings } = persistedSettings
  const preset = useMemo(() => onGetSettings(true), [onGetSettings])
  // const pitchShiftCents = usePitchInitialState({ mainOperations, preset })

  return useMemo(() => {
    const channels = preset?.channels || []
    return {
      channels,
      isRepeating: preset?.general?.isRepeating,
      typeChords: preset?.general?.typeChords,
      masterVolume: preset?.general?.masterVolume,
      // pitchShiftCents,
      // playbackRate: preset?.general?.playbackRate,
      panels: preset?.panels,
      countIn: preset?.general?.countIn
    }
  }, [
    // pitchShiftCents,
    preset?.channels,
    preset?.general?.typeChords,
    preset?.general?.countIn,
    preset?.general?.isRepeating,
    preset?.general?.masterVolume,
    // preset?.general?.playbackRate,
    preset?.panels
  ])
}
